import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import "./selectMenu.scss";
import FormHelperText from "@mui/material/FormHelperText";
import commonImages from "../../../assets";
import { OutlinedInput } from "@mui/material";
import selectIcon from "./selectmenuIcon";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function SelectMenu({
  listData,
  onChange,
  value,
  name,
  isError = false,
  errorMessage,
  placeholder,
  disabledDefault = true,
  disabled,
}) {
  return (
    <div className="overideSelectMenu">
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        value={value}
        disabled={disabled}
        onChange={onChange}
        size="small"
        displayEmpty={true}
        MenuProps={MenuProps}
        renderValue={(value) =>
          value?.length ? (
            value.map((i) => i.value).join(", ")
          ) : (
            <div className="placeholder">Please Select</div>
          )
        }
        className="selectBox"
        name={name}
        IconComponent={selectIcon}
        //   IconComponent={() => (
        //     <ExpandMoreOutlinedIcon size="large" className="expIcon" />
        //   )}
        //
      >
        {listData &&
          listData?.map((name) => (
            <MenuItem
              key={name.key}
              value={name}
              className="selectutilityitems"
            >
              <img
                // style={{marginRight:"5px"}}
                className="multiCheck"
                title={
                  value?.indexOf(name) > -1 ? "tickCheckbox" : "untickCheckbox"
                }
                alt=""
                src={
                  value?.indexOf(name) > -1
                    ? commonImages.check
                    : commonImages.noCheck
                }
              />
              <ListItemText primary={name.value} />
            </MenuItem>
          ))}
      </Select>
      {isError && value.length === 0 && (
        <FormHelperText className="errorText">
          {errorMessage ? errorMessage : "Required"}
        </FormHelperText>
      )}
    </div>
  );
}
